import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/purchaseOrders/PurchaseOrdersUIHelpers";

const initialPurchaseOrdersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  purchaseOrderForEdit: undefined,
  lastError: null,
  type: null,
  listLoadingObjectData: false,
  objectsData: [],
  queryParams: initialFilter,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState: initialPurchaseOrdersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPurchaseOrderById
    purchaseOrderFetched: (state, action) => {
      state.actionsLoading = false;
      state.purchaseOrderForEdit = action.payload.purchaseOrderForEdit;
      state.error = null;
    },
    // findPurchaseOrders
    purchaseOrdersFetched: (state, action) => {
      const { totalCount, entities, type } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.purchaseOrderForEdit = null;
      state.type = type;
    },
    // deletePurchaseOrder
    purchaseOrderDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    purchaseOrderCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    purchaseOrderUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // Query Params
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    // ObjectsData
    objectsDataFetchedByType: (state, action) => {
      const { objectsData } = action.payload;
      state.error = null;
      state.objectsData = objectsData.map((x) => {
        return { ...x, label: `${x.searchKey} | ${x.objectType}` };
      });
      state.actionsLoading = false;
    },
    // Clean Filter
    setValueCleanRefFilter: (state, action) => {
      state.cleanRefFilters = action.payload.flag;
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    endCleanRefFilter: (state, action) => {
      state.cleanRefFilters = action.payload.flag;
    },
  },
});
